var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUiQuestCompleteTrophyLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 166.786 172.757"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "UI-quest-complete-trophy-large_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 159741",
  fill: "none",
  d: "M0 0h104.565v172.757H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "UI-quest-complete-trophy-large_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 159742",
  fill: "none",
  d: "M0 0h166.786v60.801H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 28548"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27653",
  transform: "translate(31.37)",
  clipPath: "url(#UI-quest-complete-trophy-large_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36627",
  d: "M68.502 117.762H28.015a2.582 2.582 0 00-2.582 2.582v11.438h46.482v-11.457c-.312-2.058-3.411-2.563-3.411-2.563",
  fill: "#d6eff4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36628",
  d: "M57.946 97.563a12.977 12.977 0 011.215-7.456c1.75-3.4 4.007-4.12 4.007-4.12l-2.626-4.734H44.186l-1.592 2.87-1.034 1.864s2.426.73 4.187 4.5a11.373 11.373 0 01.669 1.866c2.874-1.8 5.455-3.316 5.96-3.277 1.24.095 3.794 3.879 3.794 3.879s.662 18.354.946 20.908c.094.847-3.506 2.341-8.634 3.94l20.479.059c-7.672-4.391-10.23-13.4-11.015-20.295",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36629",
  d: "M57.117 113.859c-.284-2.554-.946-20.908-.946-20.908s-2.554-3.784-3.794-3.879c-.505-.039-3.086 1.476-5.96 3.277a13.778 13.778 0 01.327 5.256c-.841 6.885-3.467 15.827-11.141 20.157h.973l11.906.034c5.128-1.6 8.729-3.093 8.634-3.94",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36630",
  d: "M76.547 117.762h-8.045s3.1.5 3.411 2.563v5.412l-46.476 2.721h46.479v3.324h7.216v-11.438a2.582 2.582 0 00-2.582-2.582",
  fill: "#85abb3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36631",
  d: "M15.699 128.457a4.063 4.063 0 00-4.063 4.063v31.968h18.586l26.126-36.031z",
  fill: "#d6eff4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36632",
  d: "M80.083 128.457H56.348l-26.13 36.031h21.42l30.365-3.306a4.556 4.556 0 004.063-4.529v-26.225c-1.029-1.5-5.987-1.971-5.987-1.971",
  fill: "#aee0ea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36633",
  d: "M88.867 128.458h-8.783s4.958.474 5.987 1.971v26.225a4.556 4.556 0 01-4.063 4.529l-30.362 3.306h41.287v-31.968a4.063 4.063 0 00-4.063-4.063",
  fill: "#85abb3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36634",
  d: "M52.282-.003a1.266 1.266 0 00-1.151.719L35.757 32.162l16.525 22.616z",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36635",
  d: "M52.283 83.022l30.92 16.4a1.265 1.265 0 001.519-.252L52.284 54.776z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36636",
  d: "M21.363 99.424l30.919-16.4V54.943L20.063 99.358a1.258 1.258 0 001.3.066",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36637",
  d: "M53.434.719a1.266 1.266 0 00-1.151-.722v54.781l.06.082 16.465-22.7z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36638",
  d: "M35.757 32.162L1.102 37.067a1.264 1.264 0 00-1.033.859L52.282 54.84v-.063z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36639",
  d: "M84.721 99.172a1.249 1.249 0 00.344-1.1l-6.044-34.475-26.678-8.735z",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36640",
  d: "M19.5 98.07a1.262 1.262 0 00.564 1.288l32.219-44.416v-.041l-26.742 8.694z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36641",
  d: "M.069 37.926a1.265 1.265 0 00.321 1.331l25.154 24.338 26.738-8.692v-.061z",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36642",
  d: "M104.496 37.926a1.264 1.264 0 00-1.033-.859l-34.655-4.905-16.465 22.7.034.011z",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36643",
  d: "M104.496 37.926L52.377 54.871l26.644 8.724 25.154-24.338a1.264 1.264 0 00.321-1.331",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36644",
  d: "M52.282 3.493c.329 8.562.478 17.125.618 25.688l.114 12.844c.018 4.281.09 8.563.063 12.844l-.006.972-.911-.3c-7.217-2.4-14.464-4.718-21.656-7.2-7.2-2.447-14.4-4.927-21.547-7.534 7.322 2.081 14.6 4.289 21.872 6.531 7.281 2.208 14.507 4.584 21.763 6.867l-.917.668c-.043-4.282.014-8.563.016-12.845l.067-12.845c.109-8.563.226-17.126.524-25.69",
  fill: "#ffe36c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36645",
  d: "M22.134 96.404c4.787-7.107 9.72-14.107 14.66-21.1l7.488-10.437c2.512-3.467 4.98-6.966 7.529-10.406l.578-.781.557.783c4.407 6.2 8.892 12.344 13.235 18.591 4.372 6.226 8.714 12.473 12.949 18.8-4.683-6-9.257-12.08-13.8-18.18-4.575-6.079-9.007-12.261-13.517-18.387h1.135c-2.492 3.482-5.064 6.9-7.593 10.36l-7.634 10.33c-5.141 6.849-10.289 13.693-15.583 20.43",
  fill: "#ffe36c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36646",
  d: "M82.623 96.403c-5.295-6.737-10.443-13.581-15.585-20.429l-7.635-10.33c-2.529-3.455-5.1-6.878-7.594-10.359l-.566-.791.916-.289c7.254-2.291 14.477-4.675 21.756-6.89 7.267-2.249 14.545-4.465 21.865-6.554-7.148 2.615-14.338 5.1-21.539 7.557-7.189 2.488-14.434 4.809-21.648 7.221l.35-1.08c2.549 3.44 5.017 6.939 7.53 10.406l7.488 10.436c4.94 7 9.874 14 14.662 21.1",
  fill: "#ffe36c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36647",
  d: "M95.748 164.656a2.966 2.966 0 01.125.81v2.278a3 3 0 01-3 3H7.841a2.962 2.962 0 01-.947-.167 2.986 2.986 0 002.87 2.186h85.037a3 3 0 003-3v-2.277a2.986 2.986 0 00-2.049-2.828",
  fill: "#85abb3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36648",
  d: "M92.877 170.739a3 3 0 003-3v-2.278a2.964 2.964 0 00-.125-.809 2.96 2.96 0 00-.947-.167H9.764a3 3 0 00-3 3v2.278a2.966 2.966 0 00.125.81 2.965 2.965 0 00.947.167z",
  fill: "#aee0ea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36649",
  d: "M35.384 148.169a1.75 1.75 0 010-3.5h9.209l4.942-6.816H30.074a2.134 2.134 0 00-2.135 2.134v12.97a2.135 2.135 0 002.135 2.135h6.961l5.022-6.927z",
  fill: "#f9f9f9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36650",
  d: "M74.492 137.854H49.535l-4.942 6.816h24.589a1.75 1.75 0 110 3.5H42.057l-5.022 6.927h37.457a2.134 2.134 0 002.134-2.135v-12.97a2.134 2.134 0 00-2.134-2.134",
  fill: "#ededed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36651",
  d: "M33.635 146.418a1.748 1.748 0 001.748 1.748h6.674l2.535-3.5h-9.209a1.748 1.748 0 00-1.748 1.748",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36652",
  d: "M69.181 148.166a1.75 1.75 0 100-3.5H44.592l-2.535 3.5z",
  fill: "#f59c0f"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 28549"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27656"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27655",
  clipPath: "url(#UI-quest-complete-trophy-large_svg__b)",
  transform: "translate(0 103.912)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36653",
  d: "M140.006 17.4a24.83 24.83 0 005.824 1.435C152.834 10.861 158.449 0 158.449 0c-13.606 9.7-40.9 13.492-45.031 17.337.466.383 1.45.673 3.332.735 6.857.229 15.818-3.533 23.257-.674",
  fill: "#d6eff4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36654",
  d: "M122.407 39.298c4.761-3.746 31.058-7.945 44.384-17.443 0 0-14.91.767-21.484-2.415.178-.2.352-.4.529-.606a24.828 24.828 0 01-5.829-1.436c-7.438-2.859-16.4.9-23.257.674-1.882-.063-2.866-.353-3.332-.735-.022.021-.053.041-.073.061-.521 1.547.766 2.526 2.162 2.894a9.546 9.546 0 004.191-.176c1.863-.361 3.73-.7 5.6-1.014a70.634 70.634 0 018.213-1.007 7.753 7.753 0 012.933.171c.034.013.459.183.374.29l-11.071 13.929z",
  fill: "#85abb3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36655",
  d: "M112.793 18.338c-.45 3.144 6.93 20.326 6.93 20.326l1.791 1.877a2.114 2.114 0 01.888-1.243l3.347-6.813 11.071-13.929c.085-.107-.341-.277-.374-.29a7.758 7.758 0 00-2.933-.171 70.682 70.682 0 00-8.213 1.007c-1.872.31-3.738.653-5.6 1.014a9.545 9.545 0 01-4.192.176c-1.4-.368-2.684-1.346-2.162-2.894a1.718 1.718 0 00-.551.94",
  fill: "#aee0ea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36656",
  d: "M21.484 19.439C14.235 11.425 8.338 0 8.338 0c13.678 9.749 41.2 13.533 45.1 17.4.521 1.547-.766 2.526-2.162 2.894a9.548 9.548 0 01-4.192-.176c-1.863-.361-3.73-.7-5.6-1.014a70.64 70.64 0 00-8.213-1.007 7.753 7.753 0 00-2.933.171c-.033.013-.459.183-.374.29l11.074 13.927 3.346 6.815C39.623 35.552 13.327 31.353 0 21.855c0 0 14.91.767 21.484-2.415",
  fill: "#d6eff4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36657",
  d: "M53.989 18.338c.45 3.144-6.93 20.326-6.93 20.326l-1.791 1.877a2.115 2.115 0 00-.888-1.243l-3.346-6.813-11.068-13.929c-.085-.107.341-.277.374-.29a7.757 7.757 0 012.933-.171 70.669 70.669 0 018.216 1.007c1.872.31 3.738.653 5.6 1.014a9.545 9.545 0 004.192.176c1.4-.368 2.684-1.346 2.162-2.894a1.718 1.718 0 01.551.94",
  fill: "#85abb3"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27657"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36658",
  d: "M35.953 129.983c14.971 5.371 48 4.2 48 4.2v-.013a134.634 134.634 0 01-29.175-3.058c-9.242-2.011-17.85-4.809-24.81-8.646-8.353 15.467-9.676 26.913-9.676 26.913.172.095.352.183.525.277 8.126-20.754 15.136-19.673 15.136-19.673",
  fill: "#aee0ea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36659",
  d: "M136.82 122.467c-6.96 3.838-15.568 6.636-24.81 8.646a134.609 134.609 0 01-28.06 3.058v.013s-33.026 1.17-48-4.2c0 0-7.01-1.08-15.136 19.673a111.116 111.116 0 0013.188 6.056 140.37 140.37 0 0045.388 8.924v.026c.653.021 1.3.014 1.951.024.682.012 1.365.024 2.05.025s1.368-.013 2.05-.025c.651-.01 1.3 0 1.951-.024v-.026a140.369 140.369 0 0045.383-8.923 110.669 110.669 0 0013.718-6.335s-1.322-11.446-9.676-26.913",
  fill: "#d6eff4"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31206",
  transform: "translate(-13.062 105.124)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 158835",
  width: 81,
  height: 25,
  rx: 4,
  transform: "translate(55.955 29.188)",
  fill: "#ebf7fa"
}), /*#__PURE__*/React.createElement("text", {
  "data-name": "1,000 PTS",
  transform: "translate(61.955 46.188)",
  fill: "#25358e",
  fontSize: 14,
  fontFamily: "AvenirNext-Bold, Avenir Next",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1,000 PTS"))))));
export default __webpack_public_path__ + "static/UI-quest-complete-trophy-large.66609740ca43256f59cc4ae6388b9618.svg";
export { SvgUiQuestCompleteTrophyLarge as ReactComponent };